import React, { useState } from 'react';
import UtilityButton from './utilityButton';
import { useBookingContext } from '../../contexts/bookingContext';
import { useTranslation } from 'react-i18next';
import HotelRequest from '../destination/hotelRequest';

const ButtonBooking = ({
  blok,
  hotel,
  price,
  priceType,
  destination,
  season,
  parentColor,
  showPrice = true,
  showPackageInfo = true,
}) => {
  const {
    setVisible,
    setSeason,
    setDestination,
    setHotel,
    setIsFullscreenModal,
    setDepartureDate,
  } = useBookingContext();

  const { t } = useTranslation(['booking']);

  const [showRequestForm, setShowRequestForm] = useState(false);

  let label = t('Book now');
  /*if (priceType === 'package') {
    label = t('PackagePrice', {
      price: price.lowestPerPersonPrice.toLocaleString('sv-SE'),
    });
  } else*/
  if (showPrice && price) {
    label = t('StartingPrice', {
      price: price.lowestPerPersonPrice.toLocaleString('sv-SE'),
    });
    setDepartureDate(price.travelDateFrom);
  } else if (!price && !blok.show_modal) {
    if (hotel?.coming_soon) {
      label = t('Coming soon');
    } else {
      label = t('Send request');
    }
  }

  const show = () => {
    //setSeason(season?.toLowerCase());
    //setDestination(destination);
    setDepartureDate(price.travelDateFrom);
    setHotel(hotel);
    setVisible(true);
    setIsFullscreenModal(true);
  };

  const enabled = !hotel?.coming_soon;

  return (
    <div className="col-span-12">
      <UtilityButton
        label={label}
        padding={blok.padding}
        buttonType={blok.type}
        parentColor={enabled ? parentColor : 'gray'}
        onClick={
          enabled
            ? price || blok.show_modal
              ? () => show()
              : () => setShowRequestForm(true)
            : () => {}
        }
        enabled={enabled}
        priceType={priceType}
        showPackageIcon={priceType === 'package'}
      />
      {showPackageInfo && price && (
        <span className="info text-xxs w-full flex items-center  pb-6">
          <span className="pt-0.5 ">
            {price.hotelName ? (
              <span>
                {price.packageShortInfo}.{' '}
                {t('priceReference', {
                  airport: price.airport,
                  travelDateFrom:
                    price.travelDateFrom && price.travelDateFrom.substr(0, 10),
                  hotelName: price.hotelName,
                  roomDescription:
                    (price.roomProposal &&
                      price.roomProposal.roomDescriptions[0]) ||
                    '',
                })}
              </span>
            ) : (
              <span>
                {price.packageShortInfo}.{' '}
                {t('priceReferenceWithoutHotel', {
                  airport: price.airport,
                  travelDateFrom:
                    price.travelDateFrom && price.travelDateFrom.substr(0, 10),
                  roomDescription:
                    (price.roomProposal &&
                      price.roomProposal.roomDescriptions[0]) ||
                    '',
                })}
              </span>
            )}
          </span>
        </span>
      )}
      <HotelRequest
        showRequestModal={showRequestForm}
        setShowRequestModal={setShowRequestForm}
        hotel={hotel}
      />
    </div>
  );
};

export default ButtonBooking;
